import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12448d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative min-h-[400px]" }
const _hoisted_2 = { class: "w-full flex flex-wrap items-center justify-between my-8 gap-4" }
const _hoisted_3 = { class: "flex-1 min-w-[200px] md:min-w-[280px] order-1" }
const _hoisted_4 = {
  key: 0,
  class: "export-wrapper absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg border border-black/5 focus:outline-none z-20"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar para Excel", -1))
const _hoisted_6 = {
  key: 0,
  class: "my-4 flex flex-wrap gap-2 items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_8 = {
  key: 1,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_9 = {
  key: 2,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_10 = {
  key: 3,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_11 = {
  key: 4,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_12 = {
  key: 5,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_13 = { class: "flex flex-col gap-y-4" }
const _hoisted_14 = {
  key: 0,
  class: "mt-8 flex justify-center"
}

import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { ref, onMounted, onBeforeUnmount, computed, defineAsyncComponent, watch } from 'vue'
import HistoryShiftCard from './HistoryShiftCard.vue'
import EmptyList from '@/components/EmptyList.vue'
import type { HandoverInviteResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import HandoverInviteService, { HandoverInviteStatus } from '@/Network/Services/HandoverInvites'
import {
  StationToUpdate,
  mapCoverageToStationUpdate
} from '../Dashboard/modals/createStation/helpers'
import UpdateStationModal from '../Dashboard/modals/updateStation/update.station.modal.vue'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'
import SelectFilter from '@/components/Filters/SelectFilter.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import OutlineButton from '../../../components/designSystem/Buttons/OutlineButton/index.vue'
import { mdiChevronDown, mdiChevronUp, mdiFilterVariant } from '@mdi/js'
import { format } from 'date-fns'
import TimeFilter from '@/components/Filters/TimeFilter.vue'
import { timeOptions } from '@/utils/timeOptions'
import { ListHandoverHistoryParams } from '@/Network/Types/Requests/HandoverInviteRequests'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { storeToRefs } from 'pinia'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import Axios from 'axios'
import TermsOfUseModal from './modals/terms.of.use.modal.vue'
import StationDetailsModal from '../Dashboard/components/stationDetailsModal.vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'
import HistoryShiftCardSkeleton from '@/components/designSystem/Skeleton/HistoryShiftCardSkeleton.vue'

interface DateRange {
  start: Date | null
  end: Date | null
}

const itemsPerPage = 6

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftChangeHistory',
  props: {
    isActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const scaleIcon = defineAsyncComponent(() => import('@/assets/icons/scale.vue'))
const hospitalIcon = defineAsyncComponent(() => import('@/assets/icons/hospital.vue'))
const positionIcon = defineAsyncComponent(() => import('@/assets/icons/position.vue'))
const clockIcon = defineAsyncComponent(() => import('@/assets/icons/clock.vue'))
const excelIcon = defineAsyncComponent(() => import('@/assets/icons/excel.vue'))
const accountGroupIcon = defineAsyncComponent(() => import('@/assets/icons/AccountGroupIcon.vue'))

const isDashboardV2 = useFeatureFlags().flags.enabledDashboardV2



watch(
  () => props.isActive,
  (newIsActiveValue) => {
    if (!newIsActiveValue) {
      activeFilter.value = null
    }
  }
)

let searchDebounceTimer: number
const toast = useToast()
const textInput = ref('')
const selectedStartDate = ref<string | null>(null)
const selectedEndDate = ref<string | null>(null)
const loading = ref(false)

const currentPage = ref(1)
const totalHistoryItems = ref(0)

const historyData = ref<HandoverInviteResponse[]>([])
const isLoading = ref(true)
const error = ref<string | null>(null)

const handoverService = new HandoverInviteService()
const pageCount = computed(() => {
  return Math.ceil(totalHistoryItems.value / itemsPerPage)
})

const showMobileFilters = ref(false)
const showExportMenu = ref(false)
const showDetailsModal = ref(false)
const showUpdateModal = ref(false)

const stationSelected = ref<StationToUpdate | null>(null)
const selectedHealthUnitLabel = ref<string | null>(null)
const selectedDateLabel = ref<string | null>(null)
const selectedScheduleLabel = ref<string | null>(null)
const selectedTimeLabel = ref<string | null>(null)
const selectedPositionLabel = ref<string | null>(null)
const initialHourStart = ref('00:00')
const initialHourEnd = ref('23:45')
const activeFilter = ref<string | null>(null)
const selectedScheduleId = ref<string | null>(null)
const selectedHealthUnitId = ref<string | null>(null)
const selectedPositionId = ref<string | null>(null)
const operationalGroupOptions = ref<{ label: string; value: string }[]>([])
const selectedOperationalGroup = ref<string | null>(null)

const isTermsModalOpen = ref(false)
const selectedHistoryItemForTerms = ref<HandoverInviteResponse | null>(null)

const doctorStore = useDoctorStore()
const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()

const { listHealthUnits } = storeToRefs(healthUnitStore)
const { listSchedules } = storeToRefs(scheduleStore)

const healthUnitOptions = computed(() =>
  listHealthUnits.value.map((unit) => ({
    label: unit.title,
    value: String(unit.value)
  }))
)

const scheduleOptions = computed(() =>
  listSchedules.value.map((schedule) => ({
    label: schedule.title,
    value: String(schedule.value)
  }))
)

const positionsData = ref<any[]>([])
const positionsOptions = computed(() =>
  positionsData.value.map((pos) => ({
    label: pos.name,
    value: String(pos.id)
  }))
)

async function fetchHistoryData(page: number) {
  isLoading.value = true
  error.value = null

  try {
    const offset = (page - 1) * itemsPerPage

    const params: ListHandoverHistoryParams = {
      limit: itemsPerPage,
      offset: offset,
      status: [HandoverInviteStatus.ACCEPTED]
    }
    if (textInput.value) {
      params.query = textInput.value
    }
    if (selectedStartDate.value) {
      params.startDate = selectedStartDate.value
    }
    if (selectedEndDate.value) {
      params.endDate = selectedEndDate.value
    }
    if (selectedTimeLabel.value) {
      params.startTime = initialHourStart.value
      params.endTime = initialHourEnd.value
    }

    if (selectedScheduleLabel.value) {
      params.scheduleName = selectedScheduleLabel.value
    }
    if (selectedHealthUnitLabel.value) {
      params.unitName = selectedHealthUnitLabel.value
    }
    if (selectedPositionLabel.value) {
      params.positionName = selectedPositionLabel.value
    }
    if (selectedOperationalGroup.value) {
      params.operationalGroups = [selectedOperationalGroup.value]
    }

    const response = await handoverService.listHistory(params)

    historyData.value = response.data
    totalHistoryItems.value = response.count
    currentPage.value = page
  } catch (err) {
    console.error('Falha ao buscar dados da API:', err)
    error.value = 'Ocorreu um erro ao carregar o histórico. Tente novamente mais tarde.'
  } finally {
    isLoading.value = false
  }
}

// eslint-disable-next-line complexity
function handleViewShift(handoverId: number | string) {
  const item = historyData.value.find((h) => h.id === handoverId)
  if (!item || !item.doctorStation || !item.doctorStation.station) {
    console.error('Dados do plantão não encontrados para o ID:', handoverId)
    return
  }

  const stationForModal: StationToUpdate = {
    stationId: item.doctorStation.station.id,
    companyId: item.doctorStation.station.schedule?.healthUnit?.company?.id ?? 0,
    doctorStationId: item.doctorStation.id,
    date: new Date(item.doctorStation.date),
    startHour: new Date(item.doctorStation.startHour),
    endHour: new Date(item.doctorStation.endHour),
    timezone: item.doctorStation.station.timezone ?? '-03:00',
    stationType: item.doctorStation.station.type ?? 'N/A',
    ourTeam: item.doctorStation.station.ourTeam ?? false,
    value: item.doctorStation.value ?? 0,
    stationValue: item.doctorStation.station.value ?? 0,
    inCash: item.doctorStation.inCash ?? false,
    advanceRequested: item.doctorStation.requestAntecipe ?? false,
    advancePaid: item.doctorStation.antecipeWasPaid ?? false,
    modifiedValue: item.doctorStation.modifiedValue ?? false,
    position: item.doctorStation.station.position,
    checks: [],
    healthUnitLatitude: '',
    healthUnitLongitude: '',
    doctorId: undefined,
    doctorPending: undefined,
    urlConviteDoctor: undefined,
    userSponsor: item.doctorStation?.userSponsor,
    scheduleId: item.doctorStation?.station?.schedule?.id
  }

  stationSelected.value = stationForModal
  showDetailsModal.value = true
}

function handleViewTerms(item: HandoverInviteResponse) {
  selectedHistoryItemForTerms.value = item
  isTermsModalOpen.value = true
}

async function handleEditStation(fullStationData: any) {
  if (!stationSelected.value) return

  const exceptionStatus = fullStationData.doctorStation?.exceptionSummaryStatus || null

  stationSelected.value = {
    ...stationSelected.value,

    stationId: fullStationData.id,
    companyId: fullStationData.schedule.healthUnit.company.id,
    doctorId: fullStationData?.doctorStation?.doctor?.id || undefined,
    date: fullStationData.date,
    startHour: fullStationData.startHour,
    endHour: fullStationData.endHour,
    timezone: fullStationData.timezone,
    stationType: fullStationData.doctorStation.type,
    ourTeam: fullStationData.doctorStation.ourTeam,
    advanceRequested: fullStationData.doctorStation.requestAntecipe,
    advancePaid: fullStationData.doctorStation.antecipeWasPaid,
    modifiedValue: fullStationData.doctorStation.value,
    value: fullStationData.doctorStation.value,
    checks: fullStationData.doctorStation.doctorChecks,
    stationValue: fullStationData.value,
    position: fullStationData.position,
    doctorStationId: fullStationData.doctorStation.id,
    schedule: fullStationData.schedule,
    doctorStation: fullStationData.doctorStation,
    shift: fullStationData.shift,
    exceptionStatus: exceptionStatus,
    // H6: setor/especialidade do detalhe fresco (A9); o modal só escreve o que mudar.
    // A11: só com a flag ligada (desligada, o objeto é o da base).
    ...(isDashboardV2
      ? { sector: fullStationData.sector ?? null, specialty: fullStationData.specialty ?? null }
      : {}),
    // E-06: estado da cobertura do detalhe fresco — libera a edição sem médico.
    ...mapCoverageToStationUpdate(fullStationData)
  }

  await doctorStore.applyFilters(
    {
      search: '',
      names: [],
      crms: [],
      crmUFs: [],
      companies: [String(stationSelected.value.companyId)],
      inviteStatus: [CompanyDoctorInviteStatusEnum.ACCEPTED, CompanyDoctorInviteStatusEnum.PENDING]
    },
    false
  )

  showDetailsModal.value = false
  showUpdateModal.value = true
}

const onSearchByTabIndex = () => {
  clearTimeout(searchDebounceTimer)
  searchDebounceTimer = window.setTimeout(() => {
    fetchHistoryData(1)
  }, 500)
}

function handleClickOutside() {
  activeFilter.value = null
  showExportMenu.value = false
}

function toggleFilter(filterName: string) {
  if (activeFilter.value === filterName) {
    activeFilter.value = null
  } else {
    activeFilter.value = filterName
  }
}

const hasActiveFilters = computed(() => {
  const hasSearch = textInput.value !== ''
  const hasDate = selectedDateLabel.value !== null
  const hasTime = selectedTimeLabel.value !== null
  const hasSchedule = selectedScheduleLabel.value !== null
  const hasUnit = selectedHealthUnitLabel.value !== null
  const hasPosition = selectedPositionLabel.value !== null
  const hasGroup = selectedOperationalGroup.value !== null

  return hasSearch || hasDate || hasTime || hasSchedule || hasUnit || hasPosition || hasGroup
})

function clearAllFilters() {
  textInput.value = ''
  selectedDateLabel.value = null
  selectedStartDate.value = null
  selectedEndDate.value = null
  selectedScheduleLabel.value = null
  selectedScheduleId.value = null
  selectedHealthUnitLabel.value = null
  selectedHealthUnitId.value = null
  selectedPositionLabel.value = null
  selectedPositionId.value = null
  selectedTimeLabel.value = null
  initialHourStart.value = '00:00'
  initialHourEnd.value = '23:45'
  selectedOperationalGroup.value = null
  fetchHistoryData(1)
}

function handleCloseUpdateModal() {
  showUpdateModal.value = false
  fetchHistoryData(currentPage.value)
}

function handleGoBackFromUpdate() {
  showUpdateModal.value = false
  showDetailsModal.value = true
}

function handleUpdateSaved() {
  fetchHistoryData(currentPage.value)
  handleGoBackFromUpdate()
}

async function handlePageChange(newPage: number) {
  await fetchHistoryData(newPage)
}

const handleExport = async (): Promise<void> => {
  if (!selectedStartDate.value || !selectedEndDate.value) {
    toast.warning('Selecione um período antes de exportar')
    return
  }

  try {
    const filename = `relatorio-de-trocas-de-plantoes-${selectedStartDate.value}-${selectedEndDate.value}.xlsx`

    const link = await Network.handoverInvite.exportAcceptedHandoversXlsx({
      query: textInput.value?.trim(),
      startDate: selectedStartDate.value,
      endDate: selectedEndDate.value,
      startTime: initialHourStart.value,
      endTime: initialHourEnd.value,
      status: [HandoverInviteStatus.ACCEPTED],
      filename
    })

    document.body.appendChild(link)
    link.click()
    toast.success('Relatório exportado com sucesso')
  } catch (error) {
    if (Axios.isAxiosError(error) && error.response?.status === 404) {
      toast.warning('Nenhum apontamento encontrado dentro do período especificado')
      return
    }
    toast.error('Erro ao exportar relatório de trocas, contate um administrador!')
  } finally {
    showExportMenu.value = false
  }
}

function handleDateFilter({ start, end }: DateRange) {
  if (start && end) {
    selectedStartDate.value = format(start, 'yyyy-MM-dd')
    selectedEndDate.value = format(end, 'yyyy-MM-dd')
    selectedDateLabel.value = `Período: ${format(start, 'dd/MM/yyyy')} a ${format(end, 'dd/MM/yyyy')}`
  }
  fetchHistoryData(1)
}

function handleScheduleSelect(value: string) {
  const selected = scheduleOptions.value.find((opt) => opt.value === value)
  if (selected) {
    selectedScheduleLabel.value = selected.label
    selectedScheduleId.value = selected.value
    fetchHistoryData(1)
  }
  activeFilter.value = null
}

function handleHealthUnitSelect(value: string) {
  const selected = healthUnitOptions.value.find((opt) => opt.value === value)
  if (selected) {
    selectedHealthUnitLabel.value = selected.label
    selectedHealthUnitId.value = selected.value
    fetchHistoryData(1)
  }
  activeFilter.value = null
}

function handlePositionSelect(value: string) {
  const selected = positionsOptions.value.find((opt) => opt.value === value)
  if (selected) {
    selectedPositionLabel.value = selected.label
    selectedPositionId.value = selected.value
    fetchHistoryData(1)
  }
  activeFilter.value = null
}

function handleHourFilter(payload: { start: string; end: string }) {
  initialHourStart.value = payload.start
  initialHourEnd.value = payload.end
  selectedTimeLabel.value = `Horário: ${payload.start} - ${payload.end}`
  activeFilter.value = null
  fetchHistoryData(1)
}

function clearDate() {
  selectedDateLabel.value = null
  selectedStartDate.value = null
  selectedEndDate.value = null

  fetchHistoryData(1)
}

function clearSchedule() {
  selectedScheduleLabel.value = null
  selectedScheduleId.value = null
  fetchHistoryData(1)
}

function clearHealthUnit() {
  selectedHealthUnitLabel.value = null
  selectedHealthUnitId.value = null
  fetchHistoryData(1)
}

function clearPosition() {
  selectedPositionLabel.value = null
  selectedPositionId.value = null
  fetchHistoryData(1)
}

function clearTimeFilter() {
  selectedTimeLabel.value = null
  initialHourStart.value = '00:00'
  initialHourEnd.value = '23:45'

  fetchHistoryData(1)
}

function handleSearchIconClick() {
  clearTimeout(searchDebounceTimer)
  fetchHistoryData(1)
}

function handleOperationalGroupSelect(value: string) {
  selectedOperationalGroup.value = value
  fetchHistoryData(1)
  activeFilter.value = null
}

function clearOperationalGroup() {
  selectedOperationalGroup.value = null
  fetchHistoryData(1)
}

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  try {
    const fieldOptionsService = new FieldOptionsService()
    const [positionsRes, operationalGroupsRes] = await Promise.all([
      Network.position.get(),
      fieldOptionsService.getOperationalGroups(),
      healthUnitStore.fetchAllHealthUnitsForSelect(),
      scheduleStore.getAllSchedules(),
      fetchHistoryData(1)
    ])

    positionsData.value = positionsRes
    operationalGroupOptions.value = operationalGroupsRes.map((group) => ({
      label: group.name,
      value: group.name
    }))
  } catch (error) {
    console.error('Erro ao carregar dados iniciais da página:', error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SearchInput, {
            modelValue: textInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textInput).value = $event)),
            onInput: onSearchByTabIndex,
            onSearchClick: handleSearchIconClick,
            width: "100%",
            loading: loading.value,
            label: `Buscar...`,
            "hide-details": "",
            density: "compact"
          }, null, 8, ["modelValue", "loading", "label"])
        ]),
        _createElementVNode("div", {
          class: "relative flex-shrink-0 order-2 lg:order-3",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(OutlineButton, {
            text: "Exportar",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showExportMenu.value = !showExportMenu.value)),
            height: "32px",
            width: "124px",
            "prepend-icon": _unref(mdiChevronDown),
            disabled: isLoading.value
          }, null, 8, ["prepend-icon", "disabled"]),
          (showExportMenu.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleExport())),
                    class: "flex cursor-pointer items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                  }, [
                    _createVNode(_unref(excelIcon), {
                      width: "20",
                      height: "20"
                    }),
                    _hoisted_5
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showMobileFilters.value = !showMobileFilters.value)),
          class: "flex md:hidden items-center gap-1 px-3 h-[36px] border border-gray-300 rounded-full text-gray-500 text-sm order-3"
        }, [
          _createVNode(_component_v_icon, {
            icon: _unref(mdiFilterVariant),
            size: 18
          }, null, 8, ["icon"]),
          _createTextVNode(" Filtros "),
          _createVNode(_component_v_icon, {
            icon: showMobileFilters.value ? _unref(mdiChevronUp) : _unref(mdiChevronDown),
            size: 16
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
          'w-full flex flex-wrap gap-2 justify-start order-3 lg:w-auto lg:order-2',
          showMobileFilters.value ? '' : 'hidden md:flex'
        ])
        }, [
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(DateFilter, {
              "is-open": activeFilter.value === 'date',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleFilter('date'))),
              onSelect: handleDateFilter
            }, null, 8, ["is-open"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(TimeFilter, {
              label: "Horário",
              icon: _unref(clockIcon),
              options: _unref(timeOptions),
              "initial-start-value": initialHourStart.value,
              "initial-end-value": initialHourEnd.value,
              "is-open": activeFilter.value === 'time',
              onApply: handleHourFilter,
              onToggle: _cache[7] || (_cache[7] = ($event: any) => (toggleFilter('time')))
            }, null, 8, ["icon", "options", "initial-start-value", "initial-end-value", "is-open"])
          ]),
          _createElementVNode("div", {
            class: "relative",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (toggleFilter('schedule')), ["stop"]))
          }, [
            _createVNode(SelectFilter, {
              label: "Escala",
              icon: _unref(scaleIcon),
              options: scheduleOptions.value,
              "is-open": activeFilter.value === 'schedule',
              searchable: "",
              "dropdown-width": "w-64",
              onSelect: handleScheduleSelect
            }, null, 8, ["icon", "options", "is-open"])
          ]),
          _createElementVNode("div", {
            class: "relative",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (toggleFilter('healthUnit')), ["stop"]))
          }, [
            _createVNode(SelectFilter, {
              label: "Unidade",
              icon: _unref(hospitalIcon),
              options: healthUnitOptions.value,
              "is-open": activeFilter.value === 'healthUnit',
              searchable: "",
              "dropdown-width": "w-64",
              onSelect: handleHealthUnitSelect
            }, null, 8, ["icon", "options", "is-open"])
          ]),
          _createElementVNode("div", {
            class: "relative",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (toggleFilter('position')), ["stop"]))
          }, [
            _createVNode(SelectFilter, {
              label: "Posições",
              icon: _unref(positionIcon),
              options: positionsOptions.value,
              "is-open": activeFilter.value === 'position',
              searchable: "",
              "dropdown-width": "w-64",
              onSelect: handlePositionSelect
            }, null, 8, ["icon", "options", "is-open"])
          ]),
          _createElementVNode("div", {
            class: "relative",
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (toggleFilter('operationalGroup')), ["stop"]))
          }, [
            _createVNode(SelectFilter, {
              label: "Grupo Operacional",
              icon: _unref(accountGroupIcon),
              options: operationalGroupOptions.value,
              "is-open": activeFilter.value === 'operationalGroup',
              searchable: "",
              "dropdown-width": "w-64",
              onSelect: handleOperationalGroupSelect
            }, null, 8, ["icon", "options", "is-open"])
          ])
        ], 2)
      ]),
      (hasActiveFilters.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (selectedDateLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(selectedDateLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearDate,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            (selectedScheduleLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(selectedScheduleLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearSchedule,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            (selectedHealthUnitLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(selectedHealthUnitLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearHealthUnit,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            (selectedTimeLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(selectedTimeLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearTimeFilter,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            (selectedPositionLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createTextVNode(_toDisplayString(selectedPositionLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearPosition,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            (selectedOperationalGroup.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(selectedOperationalGroup.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearOperationalGroup,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " x ")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "ml-2 flex" }, [
              _createElementVNode("button", {
                onClick: clearAllFilters,
                class: "text-sm font-bold text-primary hover:text-primary-darken-1 transition-colors"
              }, " Limpar filtros ")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(itemsPerPage, (n) => {
              return _createVNode(HistoryShiftCardSkeleton, {
                key: `skeleton-${n}`
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!historyData.value.length)
                ? (_openBlock(), _createBlock(EmptyList, {
                    key: 0,
                    title: "Nenhum histórico de troca de plantões encontrado",
                    class: "mt-8"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyData.value, (item) => {
                      return (_openBlock(), _createBlock(HistoryShiftCard, {
                        key: item.id,
                        "history-item": item,
                        onViewShift: handleViewShift,
                        onViewTerms: ($event: any) => (handleViewTerms(item))
                      }, null, 8, ["history-item", "onViewTerms"]))
                    }), 128)),
                    (pageCount.value > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_v_pagination, {
                            modelValue: currentPage.value,
                            "onUpdate:modelValue": [
                              _cache[13] || (_cache[13] = ($event: any) => ((currentPage).value = $event)),
                              handlePageChange
                            ],
                            length: pageCount.value,
                            "total-visible": 4,
                            density: "comfortable",
                            color: "primary"
                          }, null, 8, ["modelValue", "length"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 64))
      ])
    ]),
    (stationSelected.value)
      ? (_openBlock(), _createBlock(StationDetailsModal, {
          key: 0,
          infos: stationSelected.value,
          "show-modal": showDetailsModal.value,
          "onUpdate:showModal": _cache[14] || (_cache[14] = ($event: any) => (showDetailsModal.value = $event)),
          onCloseModal: _cache[15] || (_cache[15] = ($event: any) => (showDetailsModal.value = false)),
          onEditStation: handleEditStation
        }, null, 8, ["infos", "show-modal"]))
      : _createCommentVNode("", true),
    (stationSelected.value && showUpdateModal.value)
      ? (_openBlock(), _createBlock(UpdateStationModal, {
          key: 1,
          infos: stationSelected.value,
          "exception-status": stationSelected.value.exceptionStatus,
          "show-modal": showUpdateModal.value,
          onCloseModal: handleCloseUpdateModal,
          onGoBack: handleGoBackFromUpdate,
          onSaved: handleUpdateSaved
        }, null, 8, ["infos", "exception-status", "show-modal"]))
      : _createCommentVNode("", true),
    _createVNode(TermsOfUseModal, {
      "is-open": isTermsModalOpen.value,
      "history-item": selectedHistoryItemForTerms.value,
      "onUpdate:isOpen": _cache[16] || (_cache[16] = ($event: any) => (isTermsModalOpen.value = $event))
    }, null, 8, ["is-open", "history-item"])
  ], 64))
}
}

})